import { ConditionGroupLogic, type SegmentConditionGroups } from '@reach/shared-types/conditions';
import React from 'react';
import { DescriptionAccordionNode } from './DescriptionAccordionNode';
import styles from './SegmentVisualBuilder.module.css';

interface SegmentDescriptionViewProps {
  conditionGroups: SegmentConditionGroups;
}

// Top-level groups are combined with AND.
const TOP_LEVEL_CONNECTOR = ConditionGroupLogic.AND.toUpperCase();

export const SegmentDescriptionView: React.FC<SegmentDescriptionViewProps> = ({ conditionGroups }) => {
  if (conditionGroups.length === 0) {
    return (
      <div className={styles.emptyBuilder}>
        <p>No conditions to display.</p>
      </div>
    );
  }

  return (
    <div className={styles.descriptionView}>
      {conditionGroups.map((group, i) => (
        <React.Fragment key={i}>
          {i > 0 && <div className={styles.accordionConnector}>{TOP_LEVEL_CONNECTOR}</div>}
          <DescriptionAccordionNode item={group} />
        </React.Fragment>
      ))}
    </div>
  );
};
